// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mmentor-header {
    margin-bottom: 16px;
    padding: 22px;
    border-radius: 12px;
    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 55%, #0e7490 100%);
    color: #f8fafc;
}

.mmentor-header-main {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-start;
}

.mmentor-header-identity {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    min-width: 0;
}

.mmentor-photo,
.mmentor-initials {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    flex-shrink: 0;
}

.mmentor-photo {
    object-fit: cover;
}

.mmentor-initials {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #38bdf8;
    color: #0f172a;
    font-weight: 700;
    font-size: 1rem;
}

.mmentor-title {
    margin: 0 0 4px;
    font-size: 1.45rem;
    font-weight: 700;
}

.mmentor-subtitle,
.mmentor-role {
    margin: 0 0 4px;
    color: #cbd5e1;
    font-size: 0.95rem;
}

.mmentor-cta-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.mmentor-cta-row .btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.mmentor-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 18px 20px;
    margin-bottom: 16px;
    background: #fff;
}

.mmentor-card-title {
    font-size: 1.1rem;
    font-weight: 650;
    margin: 0 0 4px;
    color: #0f172a;
}

.mmentor-card-sub {
    margin: 0 0 12px;
    color: #64748b;
    font-size: 0.92rem;
}

.mmentor-empty {
    margin: 0;
    color: #64748b;
}

.mmentor-chip-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    list-style: none;
    margin: 10px 0 0;
    padding: 0;
}

.mmentor-chip {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.14);
    font-size: 0.85rem;
}

.mmentor-card .mmentor-chip,
.mmentor-chip.is-track {
    background: #e0f2fe;
    color: #0c4a6e;
}

.mmentor-detail-name {
    margin: 0 0 12px;
    font-weight: 650;
    color: #0f172a;
}

.mmentor-details {
    margin: 0;
}

.mmentor-detail-row {
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 8px;
    padding: 8px 0;
    border-top: 1px solid #e2e8f0;
}

.mmentor-detail-row:first-of-type {
    border-top: none;
    padding-top: 0;
}

.mmentor-detail-row dt {
    margin: 0;
    color: #64748b;
    font-size: 0.88rem;
}

.mmentor-detail-row dd {
    margin: 0;
    color: #0f172a;
}

.mmentor-about {
    width: 100%;
}

.mmentor-about-body {
    margin: 10px 0 0;
    white-space: pre-wrap;
    color: #334155;
    line-height: 1.55;
}

.mmentor-split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
}

.mmentor-split > .mmentor-card {
    margin-bottom: 0;
}

.mmentor-expertise {
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid #e2e8f0;
}

.mmentor-expertise-title {
    margin: 0 0 6px;
    font-size: 0.95rem;
    font-weight: 650;
    color: #0f172a;
}

.mmentor-expertise-body {
    margin: 0;
    color: #334155;
    white-space: pre-wrap;
}

.mmentor-avail-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.mmentor-avail-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 0;
    border-top: 1px solid #e2e8f0;
}

.mmentor-avail-row:first-child {
    border-top: none;
    padding-top: 0;
}

.mmentor-avail-day {
    font-weight: 600;
    color: #0f172a;
    min-width: 96px;
}

.mmentor-avail-times {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: flex-end;
}

.mmentor-avail-pill {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 999px;
    background: #dcfce7;
    color: #166534;
    font-size: 0.85rem;
}

.mmentor-avail-duration {
    margin: 12px 0 0;
    color: #64748b;
    font-size: 0.85rem;
}

@media (max-width: 900px) {
    .mmentor-split {
        grid-template-columns: 1fr;
    }

    .mmentor-detail-row {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/mentorship/mentee/menteeMyMentor.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0EAA0E;IAC1E,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,QAAQ;IACR,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".mmentor-header {\n    margin-bottom: 16px;\n    padding: 22px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 55%, #0e7490 100%);\n    color: #f8fafc;\n}\n\n.mmentor-header-main {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 16px;\n    align-items: flex-start;\n}\n\n.mmentor-header-identity {\n    display: flex;\n    gap: 14px;\n    align-items: flex-start;\n    min-width: 0;\n}\n\n.mmentor-photo,\n.mmentor-initials {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.mmentor-photo {\n    object-fit: cover;\n}\n\n.mmentor-initials {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #38bdf8;\n    color: #0f172a;\n    font-weight: 700;\n    font-size: 1rem;\n}\n\n.mmentor-title {\n    margin: 0 0 4px;\n    font-size: 1.45rem;\n    font-weight: 700;\n}\n\n.mmentor-subtitle,\n.mmentor-role {\n    margin: 0 0 4px;\n    color: #cbd5e1;\n    font-size: 0.95rem;\n}\n\n.mmentor-cta-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    align-items: center;\n}\n\n.mmentor-cta-row .btn:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n}\n\n.mmentor-card {\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 18px 20px;\n    margin-bottom: 16px;\n    background: #fff;\n}\n\n.mmentor-card-title {\n    font-size: 1.1rem;\n    font-weight: 650;\n    margin: 0 0 4px;\n    color: #0f172a;\n}\n\n.mmentor-card-sub {\n    margin: 0 0 12px;\n    color: #64748b;\n    font-size: 0.92rem;\n}\n\n.mmentor-empty {\n    margin: 0;\n    color: #64748b;\n}\n\n.mmentor-chip-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    list-style: none;\n    margin: 10px 0 0;\n    padding: 0;\n}\n\n.mmentor-chip {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.14);\n    font-size: 0.85rem;\n}\n\n.mmentor-card .mmentor-chip,\n.mmentor-chip.is-track {\n    background: #e0f2fe;\n    color: #0c4a6e;\n}\n\n.mmentor-detail-name {\n    margin: 0 0 12px;\n    font-weight: 650;\n    color: #0f172a;\n}\n\n.mmentor-details {\n    margin: 0;\n}\n\n.mmentor-detail-row {\n    display: grid;\n    grid-template-columns: 140px 1fr;\n    gap: 8px;\n    padding: 8px 0;\n    border-top: 1px solid #e2e8f0;\n}\n\n.mmentor-detail-row:first-of-type {\n    border-top: none;\n    padding-top: 0;\n}\n\n.mmentor-detail-row dt {\n    margin: 0;\n    color: #64748b;\n    font-size: 0.88rem;\n}\n\n.mmentor-detail-row dd {\n    margin: 0;\n    color: #0f172a;\n}\n\n.mmentor-about {\n    width: 100%;\n}\n\n.mmentor-about-body {\n    margin: 10px 0 0;\n    white-space: pre-wrap;\n    color: #334155;\n    line-height: 1.55;\n}\n\n.mmentor-split {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.mmentor-split > .mmentor-card {\n    margin-bottom: 0;\n}\n\n.mmentor-expertise {\n    margin-top: 14px;\n    padding-top: 12px;\n    border-top: 1px solid #e2e8f0;\n}\n\n.mmentor-expertise-title {\n    margin: 0 0 6px;\n    font-size: 0.95rem;\n    font-weight: 650;\n    color: #0f172a;\n}\n\n.mmentor-expertise-body {\n    margin: 0;\n    color: #334155;\n    white-space: pre-wrap;\n}\n\n.mmentor-avail-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.mmentor-avail-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 10px 0;\n    border-top: 1px solid #e2e8f0;\n}\n\n.mmentor-avail-row:first-child {\n    border-top: none;\n    padding-top: 0;\n}\n\n.mmentor-avail-day {\n    font-weight: 600;\n    color: #0f172a;\n    min-width: 96px;\n}\n\n.mmentor-avail-times {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    justify-content: flex-end;\n}\n\n.mmentor-avail-pill {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: #dcfce7;\n    color: #166534;\n    font-size: 0.85rem;\n}\n\n.mmentor-avail-duration {\n    margin: 12px 0 0;\n    color: #64748b;\n    font-size: 0.85rem;\n}\n\n@media (max-width: 900px) {\n    .mmentor-split {\n        grid-template-columns: 1fr;\n    }\n\n    .mmentor-detail-row {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
